module.exports = __webpack_public_path__ + "static/media/4.e1d00d99.jpg";